import Helper from "./Helper";

class ScrollSpy {
  constructor(config = {}) {
    const { header } = config;

    this.header = document.querySelector(header || "header");

    this.lastScrollPos = 0;
    if(this.header){
      this.registerScroll();
    }
  }

  registerScroll() {
    // console.log('registerscroll');
    window.addEventListener("scroll", e => {
      // console.log('scrolling');
      this.handleScroll(e);
    });
  }

  handleScroll(e) {
    const body = document.body;
    const html = document.documentElement;

    this.maxHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    this.windowHeight = window.innerHeight;

    // console.log("handlescroll");
    let scrollTop = e.currentTarget.pageYOffset;
    let height = this.header.nextElementSibling.firstElementChild.firstElementChild.offsetHeight;
    const h = this.header;
    let scrolledUp = false;

    if (this.lastScrollPos < height) {
      this.lastScrollPos = scrollTop;
      Helper.addClass(h, "transparent-header");
      Helper.removeClass(h, "site-header--white");
    } else {
      this.lastScrollPos = scrollTop;
      Helper.removeClass(h, "transparent-header");
      Helper.addClass(h, "site-header--white");
    }
  }
}

export default ScrollSpy;
